module.exports = __webpack_public_path__ + "../resources/images/illustration_flagged-c1daa63f20107002ccb6b3b4e20526da.svg";